import { MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { AppState } from './app.state';

/** Interfaz mínima compatible con Storage (para el fallback) */
interface StorageLike {
  length: number;
  clear(): void;
  getItem(key: string): string | null;
  key(index: number): string | null;
  removeItem(key: string): void;
  setItem(key: string, value: string): void;
}

/** Storage no-op (para SSR) */
function createNoopStorage(): StorageLike {
  return {
    length: 0,
    clear: () => {},
    getItem: () => null,
    key: () => null,
    removeItem: () => {},
    setItem: () => {}
  };
}

/** Usa localStorage en browser, no-op en SSR */
const storage: StorageLike =
  typeof window !== 'undefined' && window.localStorage
    ? window.localStorage
    : createNoopStorage();

/** Si prefieres por sesión: usa window.sessionStorage cuando exista */
// const storage: StorageLike =
//   typeof window !== 'undefined' && window.sessionStorage
//     ? window.sessionStorage
//     : createNoopStorage();

export function localStorageSyncReducer(reducer: any): any {
  return localStorageSync({
    keys: [
      // Persiste SOLO lo que quieras. Ejemplos:
      // 'auth',                            // todo el slice
      { auth: ['accessToken'] }, // solo props del slice
      // No incluyas 'flow' para que NO persista
    ],
    rehydrate: true,
    storage
  })(reducer);
}

export const metaReducers: MetaReducer<AppState>[] = [localStorageSyncReducer];
